// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedPrivateRouteImport } from './routes/_authenticated/private'
import { Route as AuthenticatedFinancesRouteImport } from './routes/_authenticated/finances'
import { Route as AuthenticatedSupportIndexRouteImport } from './routes/_authenticated/support.index'
import { Route as AuthenticatedRunnersIndexRouteImport } from './routes/_authenticated/runners.index'
import { Route as AuthenticatedErrandsIndexRouteImport } from './routes/_authenticated/errands.index'
import { Route as AuthenticatedDisputesIndexRouteImport } from './routes/_authenticated/disputes.index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers.index'
import { Route as AuthenticatedSupportTicketIdRouteImport } from './routes/_authenticated/support.$ticketId'
import { Route as AuthenticatedRunnersUserIdRouteImport } from './routes/_authenticated/runners.$userId'
import { Route as AuthenticatedErrandsErrandIdRouteImport } from './routes/_authenticated/errands.$errandId'
import { Route as AuthenticatedDisputesDisputeIdRouteImport } from './routes/_authenticated/disputes.$disputeId'
import { Route as AuthenticatedCustomersUserIdRouteImport } from './routes/_authenticated/customers.$userId'

const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPrivateRoute = AuthenticatedPrivateRouteImport.update({
            id: '/private',path: '/private',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedFinancesRoute = AuthenticatedFinancesRouteImport.update({
            id: '/finances',path: '/finances',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSupportIndexRoute = AuthenticatedSupportIndexRouteImport.update({
            id: '/support/',path: '/support/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedRunnersIndexRoute = AuthenticatedRunnersIndexRouteImport.update({
            id: '/runners/',path: '/runners/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedErrandsIndexRoute = AuthenticatedErrandsIndexRouteImport.update({
            id: '/errands/',path: '/errands/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDisputesIndexRoute = AuthenticatedDisputesIndexRouteImport.update({
            id: '/disputes/',path: '/disputes/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCustomersIndexRoute = AuthenticatedCustomersIndexRouteImport.update({
            id: '/customers/',path: '/customers/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSupportTicketIdRoute = AuthenticatedSupportTicketIdRouteImport.update({
            id: '/support/$ticketId',path: '/support/$ticketId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedRunnersUserIdRoute = AuthenticatedRunnersUserIdRouteImport.update({
            id: '/runners/$userId',path: '/runners/$userId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedErrandsErrandIdRoute = AuthenticatedErrandsErrandIdRouteImport.update({
            id: '/errands/$errandId',path: '/errands/$errandId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDisputesDisputeIdRoute = AuthenticatedDisputesDisputeIdRouteImport.update({
            id: '/disputes/$disputeId',path: '/disputes/$disputeId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCustomersUserIdRoute = AuthenticatedCustomersUserIdRouteImport.update({
            id: '/customers/$userId',path: '/customers/$userId',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedRouteChildren = {
  AuthenticatedFinancesRoute: AuthenticatedFinancesRoute,AuthenticatedPrivateRoute: AuthenticatedPrivateRoute,AuthenticatedIndexRoute: AuthenticatedIndexRoute,AuthenticatedCustomersUserIdRoute: AuthenticatedCustomersUserIdRoute,AuthenticatedDisputesDisputeIdRoute: AuthenticatedDisputesDisputeIdRoute,AuthenticatedErrandsErrandIdRoute: AuthenticatedErrandsErrandIdRoute,AuthenticatedRunnersUserIdRoute: AuthenticatedRunnersUserIdRoute,AuthenticatedSupportTicketIdRoute: AuthenticatedSupportTicketIdRoute,AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,AuthenticatedDisputesIndexRoute: AuthenticatedDisputesIndexRoute,AuthenticatedErrandsIndexRoute: AuthenticatedErrandsIndexRoute,AuthenticatedRunnersIndexRoute: AuthenticatedRunnersIndexRoute,AuthenticatedSupportIndexRoute: AuthenticatedSupportIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,LoginRoute: LoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)